import React from 'react';
import IconBase from './IconBase';

const WorksheetIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M5.5,22c-0.4,0-0.8-0.1-1.1-0.5c-0.3-0.3-0.4-0.6-0.4-1v-17c0-0.4,0.2-0.8,0.4-1C4.8,2.1,5.1,2,5.5,2h8.4 c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3L19.5,7c0.1,0.1,0.3,0.3,0.3,0.5C20,7.7,20,7.9,20,8.1v12.4c0,0.4-0.1,0.8-0.5,1 c-0.3,0.3-0.6,0.5-1,0.5H5.5z M5.5,20.5h13V8h-3.8c-0.2,0-0.4-0.1-0.5-0.2C14.1,7.6,14,7.5,14,7.3V3.5H5.5V20.5z"/>
            <path d="M8.8,18c-0.2,0-0.4-0.1-0.5-0.2C8.1,17.6,8,17.5,8,17.2c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h3.5 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H8.8z"/>
            <path d="M8.8,15c-0.2,0-0.4-0.1-0.5-0.2C8.1,14.6,8,14.5,8,14.2c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h6.5 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H8.8z"/>
            <path d="M8.8,12c-0.2,0-0.4-0.1-0.5-0.2C8.1,11.6,8,11.5,8,11.2c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h6.5 c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H8.8z"/>
        </IconBase>
    )
}

export default WorksheetIcon;